import { Spinner, Center, Text, VStack } from '@chakra-ui/react'

interface LoadingSpinnerProps {
  message?: string
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
}

export default function LoadingSpinner({ message = '載入中...', size = 'lg' }: LoadingSpinnerProps) {
  return (
    <Center py={8}>
      <VStack spacing={4}>
        <Spinner size={size} color="brand.500" thickness="4px" />
        <Text color="gray.600">{message}</Text>
      </VStack>
    </Center>
  )
}